import { healthStatusSchema } from '@gb-ticket/shared-types';
import { useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/lib/api';

export const healthQueryKey = ['health'] as const;

export function useHealth() {
  return useQuery({
    queryKey: healthQueryKey,
    queryFn: () => apiFetch('/health', healthStatusSchema),
    refetchInterval: 15_000,
    retry: false,
  });
}
